import React from 'react';

const Blogposts = () => {
    return (
        <div className='lg:mt-40 mt-20 text-primary'>
            <h1 className="text-3xl text-center">Comming soon.......</h1>
        </div>
    );
};

export default Blogposts;